<template>
  <v-card>
    <v-toolbar class="mb-3">
      <v-spacer />

      <v-btn-toggle>
        <PasswordDialog
          v-model="visiblePassword"
          :item="item"
          button-title="mdi-account-key"
          max-width="300"
        />
        <UserDialog
          v-model="visibleUser"
          :item="item"
          button-title="mdi-account-edit"
          max-width="600"
          @userUpdated="onUpdated"
        />
      </v-btn-toggle>
    </v-toolbar>

    <b-table-lite
      :fields="allHeaders"
      :items="[item]"
      stacked
      borderless
      small
    >
      <template #cell()="data">
        {{ data.value }}
      </template>
      <template #cell(privileges)="data">
        <v-chip
          v-for="(privilege, i) in data.value"
          :key="i"
          class="mr-1"
          label
          outlined
          small
        >
          {{ privilege }}
        </v-chip>
      </template>
      <template #cell(groups)="data">
        <v-chip
          v-for="(group, i) in data.value"
          :key="i"
          class="mr-1"
          label
          outlined
          small
        >
          {{ group.name }}
        </v-chip>
      </template>
      <template #cell(roles)="data">
        <v-chip
          v-for="(role, i) in data.value"
          :key="i"
          class="mr-1"
          label
          outlined
          small
        >
          {{ role.name }}
        </v-chip>
      </template>
      <template #cell(active)="data">
        <v-chip
          small
          :color="data.value ? 'green' : 'red'"
        />
      </template>
      <template #cell(dateCreated)="data">
        {{ dateTimeFormat.format(data.value) }}
      </template>
    </b-table-lite>
  </v-card>
</template>

<script>
import UserDialog from '@/components/auth/UserDialog'
import PasswordDialog from '@/components/auth/PasswordDialog'
import { AUTH_URL, dateFromObjectId } from '@/main'

export default {
  components: { PasswordDialog, UserDialog },

  data: () => ({
    dateTimeFormat: new Intl.DateTimeFormat('en-US', {
      dateStyle: 'short',
      timeStyle: 'short',
    }),
    item: null,
    allHeaders: ['name', 'fullName', 'email', 'company', 'privileges', 'groups', 'roles', 'active', 'dateCreated'],
    visibleUser: false,
    visiblePassword: false,
  }),

  computed: {
    userId() {
      return this.$route.params.id
    },
  },

  methods: {
    onUpdated(user) {
      this.item = user
    },
    getData() {
      this.$axios.get(`${AUTH_URL}/users/${this.userId}`).then((response) => {
        this.item = response.data
        if (this.item.id) this.item.dateCreated = dateFromObjectId(this.item.id)
      })
    },
  },

  mounted() {
    this.getData()
  },
}
</script>
